import xhr from 'Common/utils/xhr'

const getTask = async taskId => {
  const { data } = await xhr({
    url: `/api/v1/tasks/${taskId}`,
  })

  return data
}

export default getTask
